<!--Header-->
<app-landingpage-header-child [disableLogin]="true"></app-landingpage-header-child>
<!-- End Header-->

<!-- Content -->
<div id="wrapper-kyc-account">
  <div class="card-header font-weight-bold text-primary text-center d-block w-100">
    {{'kyc.confirm_account' | translate}}</div>
  <div class="card-sub text-center">(*{{ 'kyc.confirm_account_note' | translate }})</div>
  <!-- <webcam style="width: 0; height: 0; opacity: 0; z-index: 0" [trigger]="triggerObservable"
    (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
    [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
    (initError)="handleInitError($event)"></webcam> -->
  <mat-card>

    <mat-card-content>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <!-- Thông tin doanh nghiệp -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.customer_info'| translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row" #focus tabindex="-1">
            <ng-container *ngIf="enterprises.adminUser">
              <div class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'search_form.username' | translate}}</div>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.adminUser}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.name">
              <div class="col-6 col-sm-6 col-lg-2 col-form-label text-right">
                {{(enterprises.enterpriseType == personalId?
                  'form.full_name'
                  :'search_form.enterprise_name')| translate}}
              </div>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.name}}</div>
            </ng-container>

            <!-- <div class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.enterprise_type' | translate}}</div>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{getEnterpriseTypeOptions(type)}}
            </div> -->
            <div *ngIf="enterprises.enterpriseType != personalId"
              class="col-6 col-sm-6 col-lg-2 col-form-label text-right">
              {{'search_form.status' | translate}}</div>
            <div *ngIf="enterprises.enterpriseType != personalId" [ngSwitch]="enterprises.status"
              class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">
              <span *ngSwitchCase="true">{{'form.active' | translate}}</span>
              <span *ngSwitchCase="false">{{'form.inactive' | translate}}</span>
            </div>
            <ng-container *ngIf="enterprises.birthdayDisplay">
              <div *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null"
              class="col-6 col-sm-6 col-lg-2 col-form-label text-right">
              {{'form.birthday' | translate}}</div>
              <div *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null"
                class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.birthdayDisplay}}
              </div>
            </ng-container>

            <ng-container *ngIf="enterprises.sex !== null && enterprises.sex !== undefined">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right" *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null">{{'form.sex' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4" [ngSwitch]="enterprises.sex" *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null">
                <label *ngSwitchCase="false" class="col-form-label font-weight-bold">{{'form.female' | translate}}</label>
                <label *ngSwitchCase="true" class="col-form-label font-weight-bold">{{'form.male' | translate}}</label>
              </div>
            </ng-container>

            <label *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null"
              class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'search_form.status' | translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4" [ngSwitch]="enterprises.status"
              *ngIf="enterprises.enterpriseType == personalId || enterprises.enterpriseType == null">
              <label class="col-form-label font-weight-bold" *ngSwitchCase="true">{{'form.active' | translate}}</label>
              <label class="col-form-label font-weight-bold" *ngSwitchCase="false">{{'form.inactive' |
                translate}}</label>
            </div>

            <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.type_certification' |
              translate}}</label>
            <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.enterpriseType !=
              personalId ?
              getEnterpriseTypeOptions(certificate) : getEnterpriseTypeOptions(representativeCertificateName)}}
            </div>
            <ng-container *ngIf="enterprises.certificateNo">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.gpkd' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.certificateNo}}</div>
            </ng-container>

            <ng-container *ngIf="enterprises.issuedAt">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_by' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.issuedAt}}</div>
            </ng-container>

            <ng-container *ngIf="enterprises.issuedDateDisplay">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_date' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.issuedDateDisplay}}
              </div>
            </ng-container>

            <ng-container *ngIf="enterprises.taxCode">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right"
              *ngIf="enterprises.enterpriseType != personalId && enterprises.enterpriseType != null">{{'form.tax_code' |
              translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold"
                *ngIf="enterprises.enterpriseType != personalId && enterprises.enterpriseType != null">
              {{enterprises.taxCode}}</div>
            </ng-container>
          </div>

        </mat-expansion-panel>

        <!-- Người đại diện -->
        <mat-expansion-panel *ngIf="enterprises.enterpriseType != personalId && enterprises.enterpriseType != null"
          expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.representative_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <ng-container *ngIf="enterprises.representative">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.full_name' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.representative}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.position">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.position' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.position}}</div>
            </ng-container>
            <ng-container *ngIf="representativeCertificateName">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.type_certification' |
                translate}}</label>
                <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">
                  {{getEnterpriseTypeOptions(representativeCertificateName)}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.representativeCertificateNo">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.gpkd' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">
                {{enterprises.representativeCertificateNo}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.representativeIssuedDateDisplay">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_date' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.representativeIssuedDateDisplay}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.representativeIssuedOn">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.issued_by' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.representativeIssuedOn}}
              </div>
            </ng-container>
            <ng-container *ngIf="enterprises.birthdayDisplay">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.birthday' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.birthdayDisplay}}
              </div>
            </ng-container>
            <ng-container *ngIf="enterprises.sex !== null && enterprises.sex !== undefined">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.sex' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4" [ngSwitch]="enterprises.sex">
                <label class="col-form-label font-weight-bold" *ngSwitchCase="true">{{'form.male' | translate}}</label>
                <label class="col-form-label font-weight-bold" *ngSwitchCase="false">{{'form.female' | translate}}</label>
              </div>
            </ng-container>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin liên hệ -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.contact_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <ng-container *ngIf="addresses.cityName">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.city' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{addresses.cityName}}</div>
            </ng-container>
            <ng-container *ngIf="addresses.districtName">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.district' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{addresses.districtName}}</div>
            </ng-container>
            <ng-container *ngIf="addresses.wardName">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.ward' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{addresses.wardName}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.addresses[0].address">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.address' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.addresses[0].address}}
              </div>
            </ng-container>
            <ng-container *ngIf="enterprises.email">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'headertable.email' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.email}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.phone">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'search_form.phone' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.phone}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.fax">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.fax' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.fax}}</div>
            </ng-container>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin thanh toán -->
        <mat-expansion-panel expanded="true" *ngIf="enterprises.accountNumber || enterprises.accountName || enterprises.bankName || enterprises.bankBranch">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.pay_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <ng-container *ngIf="enterprises.accountNumber">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.accnumber' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.accountNumber}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.accountName">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.accountName' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.accountName}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.bankName">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'form.bank' | translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.bankName}}</div>
            </ng-container>
            <ng-container *ngIf="enterprises.bankBranch">
              <label class="col-6 col-sm-6 col-lg-2 col-form-label text-right">{{'search_form.branch' |
                translate}}</label>
              <div class="col-6 col-sm-6 col-lg-4 col-form-label font-weight-bold">{{enterprises.bankBranch}}</div>
            </ng-container>
          </div>
        </mat-expansion-panel>

        <!-- Tệp đính kèm -->
        <mat-expansion-panel expanded="true" *ngIf="enterprises.attachments?.length">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.attach' | translate}}
              <mat-label *ngIf="!enterprises.attachments?.length">&nbsp;{{'title.no_attachment' | translate}}
              </mat-label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-upload-multi-file [isViewDetail]="true" [arrAttachments]="this.enterprises.attachments">
          </app-upload-multi-file>
        </mat-expansion-panel>

      </mat-accordion>
    </mat-card-content>

    <div class="rule-header font-weight-bold d-block w-100 mt-5">{{'form.rule' | translate}}</div>
    <div class="rule-sub mb-2">{{'kyc.rule_title' | translate}}</div>

    <ng-container *ngIf="pdfSrc != ''">
      <ngx-extended-pdf-viewer [textLayer]="true" [src]="pdfSrc" [(zoom)]="zoomLevel" [(page)]="pageCurrent"
        [showToolbar]="true" useBrowserLocale="true" height="80vh" [handTool]="false" [enablePrint]="false"
        [showDownloadButton]="false" [sidebarVisible]="true" [showRotateButton]="false" [showOpenFileButton]="false"
        [showBookmarkButton]="false" [showPropertiesButton]="true" [showUnverifiedSignatures]="true" [theme]="'dark'"
        [language]="language" [zoomLevels]="[0.5,1,1.25, 1.5, 2, 3, 4]" [showSidebarButton]="isShowSidebarButton">
      </ngx-extended-pdf-viewer>
    </ng-container>

    <!-- Tôi đồng ý với điều khoản và chấp nhận -->
    <div class="row pt-4">
      <div class="col-12">
        <mat-checkbox [(ngModel)]="checkAgree" [ngModelOptions]="{standalone: true}" color="primary">
          <span style="font-size:14px;" class="rule-link mat-stroked-button mat-primary p-0">{{'kyc.rule' |
            translate}}</span>
        </mat-checkbox>
      </div>
    </div>

    <div class="row" *ngIf="(isEnterpriseApplyVerifyVneId === 'ONLY_VNEID' || isEnterpriseApplyVerifyVneId === 'ALL')">
      <div class="col-12">
          <span style="font-size:14px; padding-left: 24px; color: blue;">{{'kyc.rule_detail' |
            translate}}</span>
      </div>
    </div>

    <mat-card-actions
      class="btn-group text-center mat-card-actions ng-tns-c1-0 pt-3 pb-5 d-flex justify-content-center">
      <button *ngIf="!isAnonymous" mat-stroked-button class="mr-3 mat-stroked-button mat-primary"
        (click)="onBackClick()">
        <mat-icon class="mr-0" color="primary">cancel</mat-icon>
        {{ 'button.cancel' | translate }}
      </button>
      <button *ngIf="isAnonymous " mat-stroked-button class="mr-3 mat-stroked-button mat-primary" (click)="onBack()">
        <mat-icon class="mr-0" color="primary">arrow_back</mat-icon>
        {{ 'button.back' | translate }}
      </button>
      <!-- <button mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" (click)="onSign()"
        [disabled]="!checkAgree">
        <mat-icon class="mr-0">save</mat-icon>
        {{'kyc.btn_confirm' | translate}}
      </button> -->
      <button  mat-stroked-button color="primary" class="mr-3 mat-stroked-button mat-primary"
        (click)="onClickBtnViewUpdate()">
        <mat-icon class="mr-0">edit</mat-icon>
        {{'button.edit_information' | translate}}
      </button>
      <button mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" (click)="onSign()" *ngIf="((isEnterpriseApplyVerifyVneId === 'NO_VNEID' || isEnterpriseApplyVerifyVneId === 'ALL') && !hashKey) || hashKey"
        [disabled]="!checkAgree || !allInfoLoaded">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{'kyc.sign' | translate}}
      </button>
      <button
        *ngIf="enterprises.enterpriseType == personalId && enterprises.enterpriseType != null && !checkCertificateType && ( ((isEnterpriseApplyVerifyVneId === 'NO_VNEID' || isEnterpriseApplyVerifyVneId === 'ALL') && !hashKey) || hashKey )"
        mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" (click)="onKycCamera()"
        [disabled]="!checkAgree || !allInfoLoaded">
        <mat-icon class="mr-0">person_outline</mat-icon>
        {{'kyc.make_ekyc' | translate}}
      </button>
      <button
        *ngIf="(isEnterpriseApplyVerifyVneId === 'ONLY_VNEID' || isEnterpriseApplyVerifyVneId === 'ALL') && !hashKey"
        mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" (click)="showModalAuthenVneid()"
        [disabled]="!checkAgree">
        <mat-icon class="mr-0">person_outline</mat-icon>
        {{'kyc.verify_identity' | translate}}
      </button>
    </mat-card-actions>

  </mat-card>

</div>

<!-- Footer -->
<app-landingpage-footer></app-landingpage-footer>
<!-- End of Footer -->
